import { useState, useRef, useEffect } from 'react'
import textFit from 'textfit'
import { delayRender, continueRender } from 'remotion'

export const TextFit = ({
  text,
  style,
  className,
  alignVert,
  alignHoriz,
  multiLine,
  detectMultiLine,
  minFontSize = 1,
  maxFontSize = 20000,
  widthOnly,
  alignVertWithFlexbox,
}: {
  text: string
  style: React.CSSProperties
  className?: string
  alignVert?: boolean
  alignHoriz?: boolean
  multiLine?: boolean
  detectMultiLine?: boolean
  minFontSize?: number
  maxFontSize?: number
  widthOnly?: boolean
  alignVertWithFlexbox?: boolean
}) => {
  // const [handle] = useState(() => delayRender())

  const wrapperRef = useRef<HTMLDivElement | null>(null)

  // Scale text to fit in container
  useEffect(() => {
    const wrapperEl = wrapperRef.current
    if (!wrapperEl) return

    textFit(wrapperEl, {
      alignVert,
      alignHoriz,
      multiLine,
      detectMultiLine,
      minFontSize,
      maxFontSize,
      widthOnly,
      alignVertWithFlexbox,
    })

    // continueRender(handle)
  }, [
    alignHoriz,
    alignVert,
    alignVertWithFlexbox,
    detectMultiLine,
    // handle,
    maxFontSize,
    minFontSize,
    multiLine,
    widthOnly,
  ])

  return (
    <div ref={wrapperRef} style={style} className={className}>
      {text}
    </div>
  )
}
